<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<div class="input-group" [class.focussed]="inputFocussed"
  [class.invalid]="currentFormControl?.invalid || (crossFieldValidators && controller.hasError(crossFieldValidators))">
  <input #inputChild [type]="currentInputType" autofocus class="form-control" [name]="controlName"
    [formControlName]="controlName" (focus)="inputFocus(true)" (focusout)="inputFocusOut()" (keydown)="onKeyDown()"
    [autocomplete]="autocomplete" (keydown.space)="$event.preventDefault()">
  <div class="input-group-append">
    <ng-container *ngIf="initInputType === 'password'">
      <button class="input-group-text show-hide" (click)="changeVisibility()">
        <svg-icon [src]="svgIcon" [svgStyle]="{ 'width.px':'20', 'height.px':'16', 'vertical-align': 'middle' }">
        </svg-icon>
      </button>
    </ng-container>
    <ng-container *ngIf="initInputType !== 'password'">
      <span class="input-group-text" [innerHTML]="inputGroupText"></span>
    </ng-container>
  </div>
</div>